import {useEffect} from "react";
import {useStoreMobx} from "@/shared/lib/mobx/useStoreMobx";
import {useModalStore} from "@/Stores/Site/ModalStore";
import {useModalStore as useModalStoreProduct} from "@/Stores/Site/Product";
import {useNotificationStore} from "@/Stores/NotificationStore";

export default function useCloseModalWindows() {
    const {modalStore} = useStoreMobx();

    const closeSearchModal = useModalStore(s => s.closeSearchModal);
    const closeWhySuchPriceModal = useModalStore(s => s.closeWhySuchPriceModal);
    const closeModalPriceInfo = useModalStoreProduct(s => s.closeModalPriceInfo);
    const closeModalFindOutPrice = useModalStoreProduct(s => s.closeModalFindOutPrice);
    const closeModalNotification = useNotificationStore(s => s.close);

    useEffect(() => {
        setTimeout(() => {
            modalStore.closeDiamondHeadsetStarsModal();
            modalStore.closeModalAdditionalChoiceSoul();
            modalStore.closeModalScanner();
            // Zustand
            closeSearchModal(); // Модальное окно "Поиск"
            closeWhySuchPriceModal(); // Модальное окно "Почему такая цена" (деталка товара)
            closeModalPriceInfo(); // Модальное окно "информация о цене"
            closeModalFindOutPrice(); // Модальное окно "узнать цену"
            closeModalNotification(); // Модальное окно "Уведомления"
        }, 10);
    }, []);
}
